<span class="loading" *ngIf="calls">Loading...</span>
